import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import React, { Component } from "react";
import {Link} from "react-router-dom";


let stencilSide = [
    {
        id: 0,
        name: "stencilSide",
        checked: true,
        text: <FormattedMessage id="app.stencil-quotation.stencil-side-1"
                                defaultMessage="Top+Bottom(On Single Stencil)"
                                description=""/>
    },
    {
        id: 1,
        name: "stencilSide",
        checked: false,
        text: <FormattedMessage id="app.stencil-quotation.stencil-side-2"
                                defaultMessage="Top"
                                description=""/>
    },
    {
        id: 2,
        name: "stencilSide",
        checked: false,
        text: <FormattedMessage id="app.stencil-quotation.stencil-side-3"
                                defaultMessage="Bottom"
                                description=""/>
    },
    {
        id: 3,
        name: "stencilSide",
        checked: false,
        text: <FormattedMessage id="app.stencil-quotation.stencil-side-4"
                                defaultMessage="Top+Bottom(On Separate Stencil)"
                                description=""/>
    },
];

class StencilSide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stencilSide: [
                {
                    id: 0,
                    name: "stencilSide",
                    checked: true,
                    text: <FormattedMessage id="app.stencil-quotation.stencil-side-1"
                                            defaultMessage="Top+Bottom(On Single Stencil)"
                                            description=""/>
                },
                {
                    id: 1,
                    name: "stencilSide",
                    checked: false,
                    text: <FormattedMessage id="app.stencil-quotation.stencil-side-2"
                                            defaultMessage="Top"
                                            description=""/>
                },
                {
                    id: 2,
                    name: "stencilSide",
                    checked: false,
                    text: <FormattedMessage id="app.stencil-quotation.stencil-side-3"
                                            defaultMessage="Bottom"
                                            description=""/>
                },
                {
                    id: 3,
                    name: "stencilSide",
                    checked: false,
                    text: <FormattedMessage id="app.stencil-quotation.stencil-side-4"
                                            defaultMessage="Top+Bottom(On Separate Stencil)"
                                            description=""/>
                }
            ]
        };
    }

    componentDidMount() {
        this.setState({
            stencilSide
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.quotation !== this.props.quotation){

            let selectedStencilSide = this.state.stencilSide.map((item) => {
                item.checked = (item.id === this.props.quotation.smtStencilParam.stencilSide);
                return item;
            });

            this.setState({
                stencilSide : selectedStencilSide
            })

        }
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-12 no-padding">
                    <div className="stencil-details-div">
                        <div className="col-md-3 text-right stencil-content-item-heading">
                            <FormattedMessage id="app.stencil-quotation.stencil-side"
                                              defaultMessage="Stencil Side"
                                              description=""
                            />
                            &nbsp; &nbsp;
                            {/*<Link id="pcbstnclSide-qLink" to="/help/stncl_side" className="glyphicon glyphicon-question-sign question-link"></Link>*/}
                        </div>

                        <div className="col-md-9 stencil-details-div-items">
                            {
                                this.props.quotation.smtStencilParam.stencilQty === 1 ?
                                    <RadioButtonGroup data={stencilSide} getParams={this.props.setStencilParams}/> : ''
                            }
                            {
                                this.props.quotation.smtStencilParam.stencilQty !== 1 ?
                                    <RadioButtonGroup data={this.state.stencilSide} getParams={this.props.setStencilParams}/> : ''
                            }


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StencilSide;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilQuotationFormFields/StencilSide.js